import { rest } from 'msw';
import learningContinuumNoStatements from '../fixtures/learning-continuum-no-statements.json';

export default [
    rest.get('/reporting-api/v3/lcapi/tests/:testKey/learning-continuum', (req, res, ctx) => {
        console.info('------- Mocking Instructional Area Data -------');
        return res(ctx.status(200), ctx.json(learningContinuumNoStatements));
    }),
];
